import React from 'react';
import Link from 'next/link';
import { LocationDistrict, LocationObject } from '@/lib/types';
import { FeedType } from '@/lib/enums';
import AvatarLocation from '../AvatarLocation';

interface NearbyLocationBarProps {
  locations: Record<string, LocationDistrict | LocationObject>;
  header: string;
  type?: FeedType;
  size: 'small' | 'medium' | 'large';
}

const NearbyLocationBar = ({
  locations,
  header,
  type,
  size = 'large',
}: NearbyLocationBarProps) => {
  return (
    <section aria-label='Nearby Locations'>
      <h2 className='border-b text-black text-lg font-bold capitalize border-b-light-gray px-4 py-2'>
        {header}
      </h2>
      <div className='w-full overflow-x-auto no-scrollbar scrollbar-hide py-2'>
        <div className='flex space-x-4 px-4 gap-x-2 flex-nowrap'>
          {Object.keys(locations).map((location) => (
            <Link
              key={location}
              href={`/${type}/${encodeURIComponent(location)}`}
              prefetch={false}
            >
              <div
                key={location}
                className='flex flex-col items-center justify-center'
              >
                <div
                  className={`flex items-center justify-center rounded-lg shadow transition-colors
                  ${
                    size === 'small'
                      ? 'w-[64px] h-[64px] sm:w-[75px] sm:h-[75px] md:w-[100px] md:h-[100px]'
                      : size === 'medium'
                        ? 'w-[72px] h-[72px] sm:w-[100px] sm:h-[100px] md:w-[125px] md:h-[125px]'
                        : 'w-[100px] h-[100px] sm:w-[100px] sm:h-[100px] md:w-[100px] md:h-[100px] lg:w-[200px] lg:h-[200px]'
                  }
                  `}
                >
                  {'image_url' in locations[location] ? (
                    <AvatarLocation
                      imageUrl={locations[location].image_url}
                      label={locations[location].label}
                    />
                  ) : (
                    <AvatarLocation label={locations[location].label} />
                  )}
                </div>
                <div
                  className={`text-center font-bold text-sm text-black ${
                    size === 'small'
                      ? 'text-xs'
                      : size === 'medium'
                        ? 'text-sm'
                        : 'text-base'
                  }`}
                >
                  {locations[location].label}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NearbyLocationBar;
